import { render } from "./ResendRegisterMail.vue?vue&type=template&id=09107177"
import script from "./ResendRegisterMail.vue?vue&type=script&lang=js"
export * from "./ResendRegisterMail.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ResendRegisterMail.vue?vue&type=style&index=0&id=09107177&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__